/* global $:false */

import { sprintf } from 'sprintf-js';

const numberFormat = function(_locale, lang){
    if(lang === 'en'){
        return {
            decimalCharacter: '.',
            digitGroupSeparator: ','
        }

    } else if(lang === 'fr'){
        return {
            decimalCharacter: ',',
            digitGroupSeparator: ' '
        }

    } else if(lang === 'es'){
        return {
            decimalCharacter: ',',
            digitGroupSeparator: ''
        }

    } else return {
        decimalCharacter: ',',
        digitGroupSeparator: '.'
    }
}

const localeCoalesce = function(locale, lang){
    const LOCALES = ['en-US'];
    const LANGS = ['pt', 'es', 'fr'];
    const FALLBACK = 'en-GB';

    if(LOCALES.includes(locale)) return locale;

    if(LANGS.includes(lang)) return lang;

    return FALLBACK;
}

const DF_CACHE = {};
const DTF_CACHE = {};
const DHF_CACHE = {};

const dateFormatForLocale = function(locale, _lang){

   if(DF_CACHE[locale]) return DF_CACHE[locale];

   const intlDTF = new Intl.DateTimeFormat(locale, {
      dateStyle: 'short'
      // year: 'numeric', month: '2-digit', day: '2-digit'
   });
   const parts = intlDTF.formatToParts(Date.UTC(1111,5,6));
   window.console.debug('JN', 'LANG', locale, parts)

   const pattern = getFormatFromParts(parts)
   DF_CACHE[locale] = pattern;
   return pattern;
}

const datetimeFormatForLocale = function(locale, _lang){

   if(DTF_CACHE[locale]) return DTF_CACHE[locale];

   const intlDTF = new Intl.DateTimeFormat(locale, {
       // year: 'numeric', month: '2-digit', day: '2-digit',
       // hour: '2-digit', minute: '2-digit'
       dateStyle: 'short', timeStyle: 'short'
   });
   const parts = intlDTF.formatToParts(Date.UTC(1111,5,6,6,9,8));
   window.console.debug('JN', 'LANG', locale, parts)

   const pattern = getFormatFromParts(parts)
   DTF_CACHE[locale] = pattern;
   return pattern;
}

const dateHourFormatLocale = function(locale, _lang) {

    if (DHF_CACHE[locale]) return DHF_CACHE[locale];

    const intlDTF = new Intl.DateTimeFormat(locale, {
        // hour: '2-digit', minute: '2-digit'
        timeStyle: 'short'
    });
    const parts = intlDTF.formatToParts(Date.UTC(1111, 5, 6, 6, 9, 8));
    window.console.debug('JN', 'LANG', locale, parts)

    const pattern = getFormatFromParts(parts);
    DHF_CACHE[locale] = pattern;
    return pattern;
}

const getFormatFromParts = (parts) => {
    // see https://www.php.net/manual/en/datetime.format.php
    const pattern = parts.map((p) => {
        if(p.type === 'literal'){
            return p.value
        } else if( p.type === 'day'){
            return p.value.length > 1 ? 'd' : 'j'
        } else if( p.type === 'month'){
            return p.value.length > 1 ? 'm' : 'n'
        } else if( p.type === 'year'){
            return p.value.length > 2 ? 'Y' : 'y'
        } else if( p.type === 'minute'){
            return 'i'
        } else if( p.type === 'hour'){
            const hasDayPeriod = parts.some((op) => op.type === 'dayPeriod')
            if (p.value.length === 2) {
                // can be 12-hour format of an hour with leading zeros or a 24-hour format
                // 09:15 AM or 09:15
                return hasDayPeriod ? 'h' : 'H'
            } else {
                // is 12-hour format or 24-hour format without leading zeros
                // 9:15 AM or 9:15
                return hasDayPeriod ? 'g' : 'G'
            }
        } else if (p.type === 'dayPeriod') {
            return "A"
        }
    }).join("")

    window.console.debug('JN', 'LANG', pattern)
    return pattern
}

/**
 * Replicates the algorithm implemented on the server side by LocaleChooser.java
 */
const chooseLocale = function(){
    const DEFAULT_LOCALE = {lang: "en", country: "GB"};

    /**
     * when we receive a language without a specific country, use these default ones
     */
    const DEFAULT_COUNTRIES = {
        "en": DEFAULT_LOCALE,
        "pt": { lang: "pt", country: "PT"},
        "fr": { lang: "fr", country: "FR"},
        "es": { lang: "es", country: "ES"}
    }

    const userLocales = window.navigator.languages.map((language) => {
        const [l, c] = language.split('-')
        return {lang: l, country: c}
    })

    window.console.debug('LANG', 'userLocales', userLocales)
    for(const l of userLocales){
        if(Object.prototype.hasOwnProperty.call(DEFAULT_COUNTRIES, l.lang)){
            if(typeof l.country === 'undefined'){
                return DEFAULT_COUNTRIES[l.lang];
            } else {
                return l;
            }
        }
    }

    return DEFAULT_LOCALE;
}

// ### Cob.Translator
// Deals with translating strings and DOM nodes.
var Translator = function(fixedLang, fixedLocale) {
    var _userLang = fixedLang,
        _userLocale = fixedLocale,
        _userLangParts;

    if(_userLocale && !_userLang){
        _userLang = _userLocale.split('-')[0];
    }

    if(fixedLang || fixedLocale){
        window.console.log(`LANG: using overrides lang:${_userLang}, locale: ${_userLocale}`);
    }

    var _loadLanguage = function(callback) {
        // already loaded
        if (_userLang){
           callback(_userLang);

        } else if (window.navigator && window.navigator.languages){
            const navigatorLocale = chooseLocale();

            _userLang = navigatorLocale.lang;
            _userLocale = `${navigatorLocale.lang}-${navigatorLocale.country}`

            window.console.log('LANG from navigator.languages: ', navigatorLocale, ' => ' , 'lang:', _userLang, 'locale:', _userLocale);

            callback(_userLang);

        } else if (typeof $ !== 'undefined') {
            window.console.log("LANG: we don't know, let's ask someone!");
            $.ajax({
                'url': 'get_user_lang',
                headers: {
                    'Accept': 'application/json'
                },
                'type': 'get',
                success: function(data) {
                    window.console.log("LANG: " + JSON.stringify(data));
                    _userLang = data.lang || 'en';
                    _userLocale = data.locale || 'en-GB';
                    _userLangParts = _userLang.split('-');
                },
                error: function() {
                    window.console.log("LANG: error obtaining user language, going with en");
                },
                complete: function() {
                    callback(_userLang);
                }
            });

        } else {
            callback(_userLang);
        }
    };

    return {
        loadLanguage: _loadLanguage,

        getLanguage: function() {
            return _userLang;
        },

        getLocale: function() {
            return localeCoalesce(_userLocale, _userLang);
        },

        getNumberFormat: function(){
            return numberFormat(_userLocale, _userLang);
        },

        translateString: function(module, key, customLocation, args) {
            let location = 'i18n';

            if (customLocation) {
                location = customLocation;
            }

            const text = $.localize(location + "/" + module, {language: _userLang}).translateString(key);
            return args ? sprintf(text, args) : text;
        },

        translate: function(module, item, forced, callback, customLocation) {
            //window.console.log("LANG: localizing to " + _userLang + " item " + item);
            var it = $(item),
                location;

            var opts = { language: _userLang };
            //**todo jone isto não devia ser ao contrário?**
            if (forced) {
                opts.skipLanguage = '/^en/';
            }
            if (callback && typeof callback === 'function') {
                opts.callback = function(data, defaultCallback) {
                    callback(data);
                    defaultCallback(data);
                };
            }
            location = 'i18n';
            if (customLocation) {
                location = customLocation;
            }

            it.find("[rel^=localize]").localize(location + '/' + module, opts);
        },

        translateCustomItem: function(moduleLocation, moduleName, item, filter) {
            //window.console.log("LANG: localizing custom item " + item + " to " + _userLang);
            var it = $(item);
            it.find("[rel^=localize]").filter(filter ? filter : "*").localize(
                moduleLocation + "/" + moduleName, {skipLanguage: /^en/, language: _userLang}
            );
        },

        // ## cob.Translator.translateStringFromMap
        //
        // Translates a string from a given json object (map); the lang will be the browser lang.
        //
        // map:         the js object with the translations; should have the form
        //              {"MODULE_NAME":{ "LANG1":{"key1":"the key 1 translation in LANG1",
        //                                        "key2":"the key 2 translation in LANG1"
        //                                       },
        //                               "LANG2":{"key1":"the key 1 translation in LANG2",
        //                                        "key2":"the key 2 translation in LANG2"
        //                                       }
        //                             },
        //                "OTHER_MODULE":...same structure
        //              }
        // moduleName: the module name where we want to translate from (first key in the map hierarchy)
        // key:        the key or key path to be translated
        // useFullKey: true|false, depending on wanting to use the key "as is" (true) or use the dots to specify the
        //             path structure to the key (false).
        //             Default is *false*
        //             Example: the key "error.not-found" will search for the following entry when useFullKey=false
        //                      {module_name:{lang:{error:{not-found:"text for not found"}}}}
        //
        //
        translateStringFromMap: function(map, moduleName, key, useFullKey) {
            var _theKey,
                _translatedMsg;

            if (key === null || key === undefined) {
                window.console.warn("LANG: WARN - key is null");
                return undefined;
            }

            //we have to rebuild the key path because keys may have '-' in their names and eval
            // will not work directly on it
            if (useFullKey) {
                _theKey = "['" + key + "']";
            } else {
                _theKey = "['" + key.split('.').join("']['") + "']";
            }

            try {
                if (map[moduleName][_userLang]) {
                    /* eslint-disable-next-line no-eval */
                    _translatedMsg = eval("map[moduleName][_userLang]" + _theKey);

                } else if (map[moduleName][_userLangParts[0]]) {
                    //if not found try searching by only the language part (maybe the user lang is like pt-PT and
                    // the map has only pt)
                    /* eslint-disable-next-line no-eval */
                    _translatedMsg = eval("map[moduleName][_userLangParts[0]]" + _theKey);

                }

                if(!_translatedMsg) {
                    window.console.warn("LANG: WARN - key '" + key + "' is not on the given map");
                    return key;
                }

                return _translatedMsg;


            } catch (e) {
                window.console.warn("LANG: WARN - key '" + key + "' is not on the given map");
            }

            return key;
        }
    };
};

export { dateHourFormatLocale, datetimeFormatForLocale, dateFormatForLocale, Translator as default };
